import Feedstock from "./Feedstock";
import ValueChain from "./ValueChain";
import React, { useState, useEffect } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    IconLookup,
    IconDefinition,
    findIconDefinition,
} from "@fortawesome/fontawesome-svg-core";
import SMEs from "./SMEs";
import PrimaryProducer from "./PrimaryProducers";
import BiowasteManager from "./BiowasteManagers";
import BrandOwner from "./BrandOwner";
import Output from "./Output";
import CardHeader from "./Utils/CardHeaderComponent";
import Impacts from "./Impacts";
import Market from "./Market";
import Technology from "./Technology";
import Interconnection from "./Interconnection";
import SDG from "./sdg";
import LocationComponent from "./Location";
import ProjectDevelopment from "./ProjectDevelopment";
import EuPolicy from "./EuPolicy";
library.add(faPlus);
const pluslookup: IconLookup = { prefix: "fas", iconName: "plus" };
const plusDefinition: IconDefinition = findIconDefinition(pluslookup);

interface QuestionnaireManagementProps {
    errors: {
        field: string;
        message: string;
    }[];
    data: {
        userRole: number;
        name: string;
        isCBE: boolean;
        status: number;

        picNumbers: string[];
        dropdownValues: {
            tab: string;
            inputName: string;
            listValue: string[];
        }[];
        customLabelValues: {
            table: string;
            property: string;
            value: string;
            id: string;
        }[];

        tAndP:
        {
            table: string;
            property: string;
            tooltip: string;
            placeholder: string;
            id: string;
        }[];
        feedstocks: {
            typeOfFeedstock: string;
            typeOfFeedstockText: string;
            typeOfFeedstockSensitive: boolean;
            origin: string;
            originText: string;
            originSensitive: boolean;
            processedLocation: string;
            processedLocationText: string;
            processedLocationSensitive: boolean;
            isEnhancingBiodiversity: string;
            isEnhancingBiodiversityText: string;
            isEnhancingBiodiversitySensitive: boolean;
            zeroPollutionPractices: string;
            zeroPollution: boolean;
            reducingWaterConsumption: boolean;
            zeroPollutionPracticesText: string;
            zeroPollutionPracticesSensitive: boolean;
            mitigationOrAdaptationClimateChange: string;
            climateChangeMitigation: boolean;
            climateChangeAdaptation: boolean;
            mitigationOrAdaptationClimateChangeText: string;
            mitigationOrAdaptationClimateChangeSensitive: boolean;
        }[];
        valueChains: {
            // All Set 0

            isCreatingOrEnablingNewValueChains: string;
            isCreatingOrEnablingNewValueChainsText: string;
            isCreatingOrEnablingNewValueChainsIsConfidential: boolean;

            // All Set 1

            noveltyOfTheFeedstock: string;
            noveltyOfTheFeedstockText: string;
            noveltyOfTheFeedstockSensitive: boolean;

            // All Set 2

            noveltyOfTheTechnologies: string;
            noveltyOfTheTechnologiesText: string;
            noveltyOfTheTechnologiesSensitive: boolean;

            // All Set 3

            noveltyOfTheMarkets: string;
            noveltyOfTheMarketsText: string;
            noveltyOfTheMarketsSensitive: boolean;
        }[];
        smEs: {
            // ### SET 4.0 ###

            areSMEsInvolvedAsBeneficiaries: string;
            picNumber: string;
            category: string[];
            otherTextBox: string;
            otherTextSensitive: boolean;

            // ### SET 4.1 ###

            b2bMultiple: string[];
            b2bMultipleText: string;
            b2bMultipleSensitive: boolean;
            // ### SET 4.2 ###

            b2cMultiple: string[];
            b2cMultipleText: string;
            b2cMultipleSensitive: boolean;
        }[];
        primaryProducers: {
            // #### SET 1 ###
            arePrimaryProducersInvolved: string;

            beneficiaryPicList: string;

            engagedInValueChainsAtProjectLevelNotInConsortiumText: string;
            engagedInValueChainsAtProjectLevelNotInConsortiumSensitive: boolean;

            // #### SET 2 ###

            primarySectorOfActivity: string;
            primarySectorOfActivityText: string;
            primarySectorOfActivitySensitive: boolean;
            // #### SET 3 ###
            primaryActivitySpecificationText: string;
            primaryActivitySpecificationSensitive: boolean;

            projectRoles: string[];
            projectRolesText: string;
            projectRolesSensitive: boolean;
        }[];
        biowasteManagers: {
            // #### SET 1 ###
            areBiowasteManagersInvolved: string;

            beneficiaryPicList: string;

            engagedInValueChainsAtProjectLevelNotInConsortiumText: string;
            engagedInValueChainsAtProjectLevelNotInConsortiumSensitive: boolean;

            // #### SET 2 ###

            primarySectorOfActivity: string;
            primarySectorOfActivityText: string;
            primarySectorOfActivitySensitive: boolean;


            primaryActivitySpecificationText: string;
            primaryActivitySpecificationSensitive: boolean;
            // #### SET 3 ###

            projectRoles: string[];
            projectRolesText: string;
            projectRolesSensitive: boolean;
        }[];
        brandOwner: {
            // #### SET 1 ###
            bioBasedProductMarketEnhancement: string;

            brandOwnersPicList: string;

            numberOfBrandOwners: number;
            numberOfBrandOwnersText: string;
            numberOfBrandOwnersSensitive: boolean;
        }[];
        outputs: {
            // set0
            typeOfOutput: string;
            typeOfOutputText: string;
            typeOfOutputConfidential: boolean;

            // set1 CBE
            natureOfNoveltyBBI: string;
            natureOfNoveltyBBIText: string;
            natureOfNoveltyBBIConfidential: boolean;
            natureOfNoveltyCBE: string;
            natureOfNoveltyCBEText: string;
            natureOfNoveltyCBEConfidential: boolean;

            // set2
            typeOfBiobasedOutput: string;
            typeOfBiobasedOutputText: string;
            typeOfBiobasedOutputConfidential: boolean;
            // set3
            finalApplications: string[];
            finalApplicationText: string;
            finalApplicationsConfidential: boolean;
            // set 4 bbi
            compositionOfFeedstocks: string;
            compositionOfFeedstocksText: string;
            compositionOfFeedstocksConfidential: boolean;
            // set 5 bbi
            environmentalPerformanceOutput: string[];
            environmentalPerformanceOutputText: string;
            environmentalPerformanceOutputConfidential: boolean;
            // set 6 bbi
            economicPerformanceOutput: string[];
            economicPerformanceOutputText: string;
            economicPerformanceOutputConfidential: boolean;
            // set 7 bbi
            productPerformanceOutput: string[];
            productPerformanceOutputText: string;
            productPerformanceOutputConfidential: boolean;
            // set 4 cbe
            isProductImprovedLifeCycleEnvironmentalPerformance: string;
            isProductImprovedLifeCycleEnvironmentalPerformanceText: string;
            isProductImprovedLifeCycleEnvironmentalPerformanceConfidential: boolean;
            // set 5 cbe
            isProductCircular: string;
            productCircular: string[];
            isProductCircularText: string;
            isProductCircularConfidential: boolean;
        }[];
        impacts: {
            //set 1 BBI CBE
            numberJobs: number;

            location: string[];
            locationText: string;
            locationSensitive: boolean;

            typeJob: string[];
            typeJobText: string;
            typeJobSensitive: boolean;

            // indirects

            numberJobsIndirect: number;

            locationIndirect: string[];
            locationIndirectText: string;
            locationIndirectSensitive: boolean;

            typeJobIndirect: string[];
            typeJobIndirectText: string;
            typeJobIndirectSensitive: boolean;
            // set 2 cbe

            isContributingToDevSkillAndCapacity: string;
            isContributingToDevSkillAndCapacityText: string;
            isContributingToDevSkillAndCapacitySensitive: boolean;

            // set 4 cbe

            nRegionalHubs: number | null;
            nRegionalHubsText: string;
            nRegionalHubsSensitive: boolean;

            // set 5 cbe

            projectHasSynergies: string;

            hasSynergiesWithEU: string[];
            hasSynergiesWithEUText: string;
            hasSynergiesWithEUSensitive: boolean;

            hasSynergiesWithNational: string[];
            hasSynergiesWithNationalText: string;
            hasSynergiesWithNationalSensitive: boolean;

            hasSynergiesWithRegional: string[];
            hasSynergiesWithRegionalText: string;
            hasSynergiesWithRegionalSensitive: boolean;

            // set 2 BBI

            scienceAndInnovation: string[];
            scienceAndInnovationText: string;
            scienceAndInnovationSensitive: boolean;

            // set 3 BBI

            educationAndSociety: string[];
            educationAndSocietyText: string;
            educationAndSocietySensitive: boolean;

            // set 4 BBI

            standardsRegulationsPolicies: string[];
            standardsRegulationsPoliciesText: string;
            standardsRegulationsPoliciesSensitive: boolean;

            // set 5 BBI

            healthSafety: string[];
            healthSafetyText: string;
            healthSafetySensitive: boolean;

            // set 6 BBI

            impactOnPrimaryProducers: string[];
            impactOnPrimaryProducersText: string;
            impactOnPrimaryProducersSensitive: boolean;

            // set 7 BBI

            regionalAndLocalImpact: string[];
            regionalAndLocalImpactText: string;
            regionalAndLocalImpactSensitive: boolean;

            // set 8 BBI

            environmentalImpact: string[];
            environmentalImpactText: string;
            environmentalImpactSensitive: boolean;

            // set 9 BBI

            contributesBiodiversity: string[];
            contributesBiodiversityText: string;
            contributesBiodiversitySensitive: boolean;
        };
        market: {
            //set1 bbi

            contributions: string[];
            contributionsText: string;
            contributionsSensitive: boolean;
            // set 1 cbe

            numberOfActionsToAttractInvestmentOrCreateAwareness: number | null;
            numberOfActionsToAttractInvestmentOrCreateAwarenessText: string;
            numberOfActionsToAttractInvestmentOrCreateAwarenessSensitive: boolean;

            // set 2

            relicableToOtherRegions: string;
            relicableToOtherRegionsText: string;
            relicableToOtherRegionsSensitive: boolean;

            // set 3

            rdcs: {
                name: string;
                ticked: boolean;
                problems: string;
                solutions: string;
                updates: string;
                raisedProblemInECPublicConsultations: string;
                raisedProblemInECPublicConsultationsText: string;
            }[];
            directives: {
                name: string;
                programs: string;
                problems: string;
                solutions: string;
                updates: string;
                raisedProblemInECPublicConsultations: string;
                raisedProblemInECPublicConsultationsText: string;
            }[];
            communications: {
                name: string;
                programs: string;
                problems: string;
                solutions: string;
                updates: string;
                raisedProblemInECPublicConsultations: string;
                raisedProblemInECPublicConsultationsText: string;
            }[];
        };
        technology: {
            //set 1
            conversionProcess: string;
            conversionProcessText: string;
            conversionProcessSensitive: boolean;
            //set 2
            trlStart: number | null;
            trlEnd: number | null;
        }[];
        locations: {
            //set 3
            country: string;
            countryFree: string;
            address: string;
            city: string;
            zipCode: string;
        }[];
        projectDevelopment: {
            circularProcesses: string;
            circularProcessesText: string;
            circularProcessesSensitive: boolean;

            reduceGHG: string;
            reduceGHGText: string;
            reduceGHGSensitive: boolean;

            zeroWaste: string;
            zeroWasteText: string;
            zeroWasteSensitive: boolean;

            zeroPollution: string;
            zeroPollutionText: string;
            zeroPollutionSensitive: boolean;

            energyEfficiency: string;
            energyEfficiencyText: string;
            energyEfficiencySensitive: boolean;
        };
        interconnections: {
            //BBIJU KPI 1
            newInterconnection: string;
            newInterconnectionText: string;
            newInterconnectionSensitive: boolean;

            feedstock: string;
            feedstockText: string;
            feedstockSensitive: boolean;

            processingManufacturing: string;
            processingManufacturingText: string;
            processingManufacturingSensitive: boolean;

            endUsers: string;
            endUsersText: string;
            endUsersSensitive: boolean;
        }[];
        sdg: {
            contributions: string[];
            contributionsText: string;
            contributionsSensitive: boolean;
        };
        euPolicies: {
            initiative: string;
            initiativeText: string;
        }[];
    };

    handleDeleteFeedstock: (feedstockIndex: number) => void;
    handleOnChangeFeedstock: (
        e: React.ChangeEvent<any>,
        feedstockIndex: number
    ) => void;
    handleAddFeedstock: () => void;

    handleDeleteValueChain: (ValueChainIndex: number) => void;
    handleOnChangeValueChain: (
        e: React.ChangeEvent<any>,
        valueChainIndex: number
    ) => void;
    handleAddValueChain: () => void;

    handleDeleteSMEs: (SMEsIndex: number) => void;
    handleOnChangeSMEs: (
        OutputIndex: number,
        e?: React.ChangeEvent<any>,
        dropDown?: {
            name: string;
            value: string[];
        }
    ) => void;
    handleAddSMEs: () => void;

    handleDeletePrimaryProducer: (PrimaryProducerIndex: number) => void;
    handleOnChangePrimaryProducer: (
        OutputIndex: number,
        e?: React.ChangeEvent<any>,
        dropDown?: {
            name: string;
            value: string[];
        }
    ) => void;
    handleAddPrimaryProducer: () => void;

    handleDeleteBiowasteManager: (BiowasteManagerIndex: number) => void;
    handleOnChangeBiowasteManager: (
        OutputIndex: number,
        e?: React.ChangeEvent<any>,
        dropDown?: {
            name: string;
            value: string[];
        }
    ) => void;
    handleAddBiowasteManager: () => void;

    handleDeleteBrandOwner: (SMEsIndex: number) => void;
    handleOnChangeBrandOwner: (
        OutputIndex: number,
        e?: React.ChangeEvent<any>,
        dropDown?: {
            name: string;
            value: string[];
        }
    ) => void;
    handleAddBrandOwner: () => void;

    handleDeleteOutput: (OutputIndex: number) => void;
    handleOnChangeOutput: (
        OutputIndex: number,
        e?: React.ChangeEvent<any>,
        dropDown?: {
            name: string;
            value: string[];
        }
    ) => void;
    handleAddOutput: () => void;

    handleOnChangeImpacts: (
        e?: React.ChangeEvent<any>,
        dropDown?: {
            name: string;
            value: string[];
        }
    ) => void;

    handleOnChangeMarket: (
        e?: React.ChangeEvent<any>,
        dropDown?: {
            name: string;
            value: string[];
        }
    ) => void;

    handleAddRDC: () => void;
    handleOnChangeRDC: (e: React.ChangeEvent<any>, rdcIndex: number) => void;
    handleDeleteRDC: (RDCIndex: number) => void;

    handleDeleteTechnology: (TechnologyIndex: number) => void;
    handleOnChangeTechnology: (
        e: React.ChangeEvent<any>,
        TechnologyIndex: number
    ) => void;
    handleAddTechnology: () => void;

    handleDeleteInterconnection: (InterconnectionIndex: number) => void;
    handleOnChangeInterconnection: (
        InterconnectionIndex: number,
        e?: React.ChangeEvent<any>,
        dropDown?: {
            name: string;
            value: string[];
        }
    ) => void;
    handleAddInterconnection: () => void;

    // handleDeletesdg: (sdgIndex: number) => void;
    handleOnChangesdg: (
        e?: React.ChangeEvent<any>,
        dropDown?: {
            name: string;
            value: string[];
        }
    ) => void;
    // handleAddsdg: () => void;

    handleAddDirective: () => void;
    handleOnChangeDirective: (
        e: React.ChangeEvent<any>,
        rdcIndex: number
    ) => void;
    handleDeleteDirective: (DirectiveIndex: number) => void;

    handleAddCommunication: () => void;
    handleOnChangeCommunication: (
        e: React.ChangeEvent<any>,
        rdcIndex: number
    ) => void;
    handleDeleteCommunication: (CommunicationIndex: number) => void;

    handleDeleteLocation: (LocationIndex: number) => void;
    handleOnChangeLocation: (
        e: React.ChangeEvent<any>,
        LocationIndex: number
    ) => void;
    handleAddLocation: () => void;

    handleOnChangeProjectDevelopment: (
        e?: React.ChangeEvent<any>,
        dropDown?: {
            name: string;
            value: string[];
        }
    ) => void;

    handleDeleteEuPolicy: (TechnologyIndex: number) => void;
    handleOnChangeEuPolicy: (
        e: React.ChangeEvent<any>,
        TechnologyIndex: number
    ) => void;
    handleAddEuPolicy: () => void;

    handleUpdate: () => void;
    handleSubmit: () => void;


    handleUpdateEditableTitle: (id: string, value: string) => void;
}

function QuestionnaireManagement({
    data,
    handleDeleteFeedstock,
    handleOnChangeFeedstock,
    handleAddFeedstock,

    handleDeleteValueChain,
    handleOnChangeValueChain,
    handleAddValueChain,

    handleDeleteSMEs,
    handleOnChangeSMEs,
    handleAddSMEs,

    handleDeletePrimaryProducer,
    handleOnChangePrimaryProducer,
    handleAddPrimaryProducer,

    handleDeleteBiowasteManager,
    handleOnChangeBiowasteManager,
    handleAddBiowasteManager,

    handleAddBrandOwner,
    handleOnChangeBrandOwner,
    handleDeleteBrandOwner,

    handleDeleteOutput,
    handleOnChangeOutput,
    handleAddOutput,

    handleOnChangeImpacts,

    handleOnChangeMarket,

    handleAddRDC,
    handleOnChangeRDC,
    handleDeleteRDC,

    handleAddTechnology,
    handleOnChangeTechnology,
    handleDeleteTechnology,

    handleDeleteInterconnection,
    handleOnChangeInterconnection,
    handleAddInterconnection,

    handleOnChangesdg,

    handleAddDirective,
    handleOnChangeDirective,
    handleDeleteDirective,

    handleAddCommunication,
    handleOnChangeCommunication,
    handleDeleteCommunication,

    handleAddLocation,
    handleOnChangeLocation,
    handleDeleteLocation,

    handleOnChangeProjectDevelopment,

    handleAddEuPolicy,
    handleOnChangeEuPolicy,
    handleDeleteEuPolicy,

    handleUpdate,
    handleSubmit,

    errors,

    handleUpdateEditableTitle
}: QuestionnaireManagementProps) {
    const [activeTab, setActiveTab] = useState("Feedstock");
    const [valueChainsIsHidden, setValueChainsIsHidden] = useState(true);
    const toggleVisibilityValueChains = () => {
        setValueChainsIsHidden((prevState) => !prevState);
    };
    const [primaryProducersAreHidden, setPrimaryProducersAreHidden] =
        useState(true);
    const toggleVisibilityPrimaryProducers = () => {
        setPrimaryProducersAreHidden((prevState) => !prevState);
    };
    const [biowasteManagersAreHidden, setBiowasteManagersAreHidden] =
        useState(true);
    const toggleVisibilityBiowasteManagers = () => {
        setBiowasteManagersAreHidden((prevState) => !prevState);
    };
    const [SMEsAreHidden, setSMEsAreHidden] = useState(true);
    const toggleVisibilitySMEs = () => {
        setSMEsAreHidden((prevState) => !prevState);
    };
    const [brandOwnersAreHidden, setBrandOwnersAreHidden] = useState(true);
    const toggleVisibilityBrandOwners = () => {
        setBrandOwnersAreHidden((prevState) => !prevState);
    };
    const [locationsAreHidden, setLocationsAreHidden] = useState(true);
    const toggleVisibilityLocations = () => {
        setLocationsAreHidden((prevState) => !prevState);
    };
    const [technologiesAreHidden, setTechnologiesAreHidden] = useState(true);
    const toggleVisibilityTechnologies = () => {
        setTechnologiesAreHidden((prevState) => !prevState);
    };
    const [projectDevHidden, setTechnologiesProjectDevHidden] = useState(true);

    const [euPoliciesAreHidden, setEuPoliciesAreHidden] = useState(true);
    const toggleVisibilityEuPolicies = () => {
        setEuPoliciesAreHidden((prevState) => !prevState);
    };
    const toggleVisibilityProjectDev = () => {
        setTechnologiesProjectDevHidden((prevState) => !prevState);
    };
    const checkForErrorKeyword = (keyword: string): boolean => {
        const regex = new RegExp(`${keyword}(\\[\\d+\\])?`);
        return errors.some((error) => regex.test(error.field));
    };
    return (
        <>
            <nav className="tab-navbar">
                <ul className="nav-links">
                    <li
                        className={activeTab == "Feedstock" ? "selected" : ""}
                        onClick={() => setActiveTab("Feedstock")}
                    >
                        <a
                            href="#"
                            className={
                                checkForErrorKeyword("Feedstocks") ||
                                    checkForErrorKeyword("Feedstock")
                                    ? "error-text-important"
                                    : ""
                            }
                        >
                            Feedstock
                        </a>
                    </li>
                    <li
                        className={activeTab == "Technology" ? "selected" : ""}
                        onClick={() => setActiveTab("Technology")}
                    >
                        <a
                            href="#"
                            className={
                                checkForErrorKeyword("Technology") ||
                                    checkForErrorKeyword("Location") ||
                                    checkForErrorKeyword("ProjectDevelopment")
                                    ? "error-text-important"
                                    : ""
                            }
                        >
                            Technology
                        </a>
                    </li>
                    <li
                        className={activeTab == "Outputs" ? "selected" : ""}
                        onClick={() => setActiveTab("Outputs")}
                    >
                        <a
                            href="#"
                            className={
                                checkForErrorKeyword("Output") ? "error-text-important" : ""
                            }
                        >
                            Outputs
                        </a>
                    </li>
                    <li
                        className={activeTab == "Value Chain" ? "selected" : ""}
                        onClick={() => setActiveTab("Value Chain")}
                    >
                        <a
                            href="#"
                            className={
                                checkForErrorKeyword("ValueChain") ? "error-text-important" : ""
                            }
                        >
                            Value Chain
                        </a>
                    </li>
                    <li
                        className={
                            activeTab == "ParticipantsCBE" || activeTab == "ParticipantsBBI"
                                ? "selected"
                                : ""
                        }
                        onClick={() => {
                            var type = data.isCBE ? "CBE" : "BBI";
                            setActiveTab("Participants" + type);
                        }}
                    >
                        <a
                            href="#"
                            className={
                                checkForErrorKeyword("PrimaryProducer") ||
                                    checkForErrorKeyword("BiowasteManager") ||
                                    checkForErrorKeyword("BrandOwner") ||
                                    checkForErrorKeyword("SME")
                                    ? "error-text-important"
                                    : ""
                            }
                        >
                            Participants
                        </a>
                    </li>
                    {data.isCBE ? null : (
                        <li
                            className={activeTab == "Interconnections" ? "selected" : ""}
                            onClick={() => setActiveTab("Interconnections")}
                        >
                            <a
                                href="#"
                                className={
                                    checkForErrorKeyword("Interconnection")
                                        ? "error-text-important"
                                        : ""
                                }
                            >
                                Interconnections
                            </a>
                        </li>
                    )}
                    <li
                        className={activeTab == "Market" ? "selected" : ""}
                        onClick={() => setActiveTab("Market")}
                    >
                        <a
                            href="#"
                            className={
                                checkForErrorKeyword("Market") ||
                                    checkForErrorKeyword("Regulation") ||
                                    checkForErrorKeyword("Directive")
                                    ? "error-text-important"
                                    : ""
                            }
                        >
                            Market and Regulatory Barriers
                        </a>
                    </li>
                    <li
                        className={activeTab == "Impacts" ? "selected" : ""}
                        onClick={() => setActiveTab("Impacts")}
                    >
                        <a
                            href="#"
                            className={
                                checkForErrorKeyword("Impacts") ? "error-text-important" : ""
                            }
                        >
                            Impacts
                        </a>
                    </li>
                    <li
                        className={activeTab == "SDGs" ? "selected" : ""}
                        onClick={() => setActiveTab("SDGs")}
                    >
                        <a
                            href="#"
                            className={
                                checkForErrorKeyword("SDG") ||
                                    checkForErrorKeyword("Sdg") ||
                                    checkForErrorKeyword("EuPolicies")
                                    ? "error-text-important"
                                    : ""
                            }
                        >
                            SDGs & EU policies
                        </a>
                    </li>
                </ul>
            </nav>
            <div className="project-container">
                <h5 className="text" dangerouslySetInnerHTML={{ __html: textDescription[activeTab] }}></h5>
                <h5 className="text" style={{ color: 'red' }}>* text boxes must not exceed 1500 characters</h5>
                <h5 className="text" style={{ color: 'red' }}>(!) icon marks mandatory fields</h5>

                {activeTab == "Feedstock" ? (
                    <>
                        <div className="error-container">
                            {errors
                                .filter((error) => error.field === "Feedstocks")
                                .map((error, index) => (
                                    <div
                                        className="error-text"
                                        key={index}
                                        style={{ marginBottom: "10px" }}
                                    >
                                        {error.message}
                                    </div>
                                ))}
                        </div>
                        <div>
                            {data.feedstocks.map((feedstock, index) => (
                                <>
                                    <Feedstock
                                        errors={errors
                                            .filter(
                                                (error) => error.field === "Feedstocks[" + index + "]"
                                            )
                                            .map((error) => error.message)}
                                        key={index}
                                        data={feedstock}
                                        isCBE={data.isCBE}
                                        status={data.status}
                                        handleOnChangeFeedstock={(e: React.ChangeEvent<any>) =>
                                            handleOnChangeFeedstock(e, index)
                                        }
                                        handleDeleteFeedstock={() => handleDeleteFeedstock(index)}
                                        dropdownValues={data.dropdownValues.filter(
                                            (item) => item.tab == "Feedstock"
                                        )}
                                        customLabelValues={data.customLabelValues.filter(
                                            (item => item.table == "Feedstock")
                                        )}
                                        handleUpdateEditableTitle={handleUpdateEditableTitle}

                                        tAndP={data.tAndP.filter(
                                            (item => item.table == "Feedstock")
                                        )}
                                    />
                                </>
                            ))}
                        </div>
                        {data.status == 1 ? (
                            <div className="mt-3">
                                <div className="text-end margin-button">
                                    <button
                                        type="button"
                                        className="add-feedstock-btn nested-button mx-4 my-1"
                                        onClick={handleAddFeedstock}
                                    >
                                        <FontAwesomeIcon icon={plusDefinition} />
                                        Add Feedstock
                                    </button>
                                </div>
                            </div>
                        ) : null}
                    </>
                ) : null}
                {activeTab == "Value Chain" ? (
                    <>
                        <div className="error-container">
                            {errors
                                .filter((error) => error.field === "ValueChain")
                                .map((error, index) => (
                                    <div
                                        className="error-text"
                                        key={index}
                                        style={{ marginBottom: "10px" }}
                                    >
                                        {error.message}
                                    </div>
                                ))}
                        </div>
                        {data.valueChains.map((ValueChainData, index) => (
                            <ValueChain
                                errors={errors
                                    .filter(
                                        (error) => error.field === "ValueChain[" + index + "]"
                                    )
                                    .map((error) => error.message)}
                                status={data.status}
                                dropdownValues={data.dropdownValues.filter(
                                    (item) => item.tab == "Value Chain"
                                )}
                                key={index}
                                data={ValueChainData}
                                handleOnChangeValueChain={(e: React.ChangeEvent<any>) =>
                                    handleOnChangeValueChain(e, index)
                                }
                                handleDeleteValueChain={() => handleDeleteValueChain(index)}
                                isCBE={data.isCBE}

                                customLabelValues={data.customLabelValues.filter(
                                    (item => item.table == "Value Chain")
                                )}
                                handleUpdateEditableTitle={handleUpdateEditableTitle}
                                tAndP={data.tAndP.filter(
                                    (item => item.table == "Value Chain")
                                )}
                            />
                        ))}

                        {data.status == 1 ? (
                            <div className="mt-3">
                                <div className="text-end margin-button">
                                    <button
                                        type="button"
                                        className="add-feedstock-btn nested-button mx-4 my-1"
                                        onClick={handleAddValueChain}
                                    >
                                        <FontAwesomeIcon icon={plusDefinition} />
                                        Add Value Chain
                                    </button>
                                </div>
                            </div>
                        ) : null}
                    </>
                ) : null}
                {activeTab == "ParticipantsCBE" || activeTab == "ParticipantsBBI" ? (
                    <>
                        {data.isCBE ? (
                            <>
                                <div className="error-container">
                                    {errors
                                        .filter((error) => error.field === "PrimaryProducer")
                                        .map((error, index) => (
                                            <div
                                                className="error-text"
                                                key={index}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                {error.message}
                                            </div>
                                        ))}
                                    {errors
                                        .filter((error) => error.field === "BiowasteManager")
                                        .map((error, index) => (
                                            <div
                                                className="error-text"
                                                key={index}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                {error.message}
                                            </div>
                                        ))}
                                    {errors
                                        .filter((error) => error.field === "BrandOwner")
                                        .map((error, index) => (
                                            <div
                                                className="error-text"
                                                key={index}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                {error.message}
                                            </div>
                                        ))}
                                    {errors
                                        .filter((error) => error.field === "SME")
                                        .map((error, index) => (
                                            <div
                                                className="error-text"
                                                key={index}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                {error.message}
                                            </div>
                                        ))}
                                </div>
                                <div className="feedstock-container">
                                    <CardHeader
                                        isHidden={primaryProducersAreHidden}
                                        toggleVisibility={toggleVisibilityPrimaryProducers}
                                        cardName="Primary Producers"
                                        handleDelete={null}
                                        notValid={checkForErrorKeyword("PrimaryProducer")}
                                    />
                                    {primaryProducersAreHidden ? null : (
                                        <>
                                            {data.primaryProducers.map(
                                                (primaryProducersData, index) => (
                                                    <PrimaryProducer
                                                        errors={errors
                                                            .filter(
                                                                (error) =>
                                                                    error.field ===
                                                                    "PrimaryProducer[" + index + "]"
                                                            )
                                                            .map((error) => error.message)}
                                                        status={data.status}
                                                        dropdownValues={data.dropdownValues.filter(
                                                            (item) => item.tab == "Primary Producer"
                                                        )}
                                                        key={index}
                                                        picNumbers={data.picNumbers}
                                                        data={primaryProducersData}
                                                        handleOnChangePrimaryProducers={(
                                                            e?: React.ChangeEvent<any>,
                                                            dropDown?
                                                        ) =>
                                                            handleOnChangePrimaryProducer(index, e, dropDown)
                                                        }
                                                        handleDeletePrimaryProducers={() =>
                                                            handleDeletePrimaryProducer(index)
                                                        }

                                                        customLabelValues={data.customLabelValues.filter(
                                                            (item => item.table == "Primary Producer")
                                                        )}
                                                        handleUpdateEditableTitle={handleUpdateEditableTitle}
                                                        tAndP={data.tAndP.filter(
                                                            (item => item.table == "Participants")
                                                        )}
                                                    />
                                                )
                                            )}
                                            {data.status == 1 ? (
                                                <div className="mt-3">
                                                    <div className="text-end margin-button">
                                                        <button
                                                            type="button"
                                                            className="add-feedstock-btn nested-button mx-4 my-1"
                                                            onClick={handleAddPrimaryProducer}
                                                        >
                                                            <FontAwesomeIcon icon={plusDefinition} />
                                                            Add Primary Producer
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </>
                                    )}
                                </div>

                                <div className="feedstock-container">
                                    <CardHeader
                                        isHidden={biowasteManagersAreHidden}
                                        toggleVisibility={toggleVisibilityBiowasteManagers}
                                        cardName="Biowaste Managers"
                                        handleDelete={null}
                                        notValid={checkForErrorKeyword("BiowasteManager")}
                                    />
                                    {biowasteManagersAreHidden ? null : (
                                        <>
                                            {data.biowasteManagers.map(
                                                (biowasteManagerData, index) => (
                                                    <BiowasteManager
                                                        errors={errors
                                                            .filter(
                                                                (error) =>
                                                                    error.field ===
                                                                    "BiowasteManager[" + index + "]"
                                                            )
                                                            .map((error) => error.message)}
                                                        status={data.status}
                                                        dropdownValues={data.dropdownValues.filter(
                                                            (item) => item.tab == "Biowaste Manager"
                                                        )}
                                                        key={index}
                                                        data={biowasteManagerData}
                                                        picNumbers={data.picNumbers}
                                                        handleOnChangeBiowasteManagers={(
                                                            e?: React.ChangeEvent<any>,
                                                            dropDown?
                                                        ) =>
                                                            handleOnChangeBiowasteManager(index, e, dropDown)
                                                        }
                                                        handleDeleteBiowasteManagers={() =>
                                                            handleDeleteBiowasteManager(index)
                                                        }

                                                        customLabelValues={data.customLabelValues.filter(
                                                            (item => item.table == "Biowaste Manager")
                                                        )}
                                                        handleUpdateEditableTitle={handleUpdateEditableTitle}
                                                        tAndP={data.tAndP.filter(
                                                            (item => item.table == "Participants")
                                                        )}
                                                    />
                                                )
                                            )}
                                            {data.status == 1 ? (
                                                <div className="mt-3">
                                                    <div className="text-end margin-button">
                                                        <button
                                                            type="button"
                                                            className="add-feedstock-btn nested-button mx-4 my-1"
                                                            onClick={handleAddBiowasteManager}
                                                        >
                                                            <FontAwesomeIcon icon={plusDefinition} />
                                                            Add Biowaste Manager
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </>
                                    )}
                                </div>
                                <div className="feedstock-container">
                                    <CardHeader
                                        isHidden={brandOwnersAreHidden}
                                        toggleVisibility={toggleVisibilityBrandOwners}
                                        cardName="Brand Owners"
                                        handleDelete={null}
                                        notValid={checkForErrorKeyword("BrandOwner")}
                                    />
                                    {brandOwnersAreHidden ? null : (
                                        <>
                                            {data.brandOwner.map((bo, index) => (
                                                <BrandOwner
                                                    errors={errors
                                                        .filter(
                                                            (error) =>
                                                                error.field === "BrandOwner[" + index + "]"
                                                        )
                                                        .map((error) => error.message)}
                                                    status={data.status}
                                                    picNumbers={data.picNumbers}
                                                    key={index}
                                                    data={bo}
                                                    handleOnChangeBrandOwner={(e, dropdown) =>
                                                        handleOnChangeBrandOwner(index, e, dropdown)
                                                    }
                                                    handleDeleteBrandOwner={() =>
                                                        handleDeleteBrandOwner(index)
                                                    }
                                                    customLabelValues={data.customLabelValues.filter(
                                                        (item => item.table == "Brand Owner")
                                                    )}
                                                    handleUpdateEditableTitle={handleUpdateEditableTitle}
                                                    tAndP={data.tAndP.filter(
                                                        (item => item.table == "Participants")
                                                    )}
                                                />
                                            ))}
                                            {data.status == 1 ? (
                                                <div className="mt-3">
                                                    <div className="text-end margin-button">
                                                        <button
                                                            type="button"
                                                            className="add-feedstock-btn nested-button mx-4 my-1"
                                                            onClick={handleAddBrandOwner}
                                                        >
                                                            <FontAwesomeIcon icon={plusDefinition} />
                                                            Add brand owners
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </>
                                    )}
                                </div>
                            </>
                        ) : (
                            <div className="error-container">
                                {errors
                                    .filter((error) => error.field === "SME")
                                    .map((error, index) => (
                                        <div
                                            className="error-text"
                                            key={index}
                                            style={{ marginBottom: "10px" }}
                                        >
                                            {error.message}
                                        </div>
                                    ))}
                            </div>
                        )}

                        <div className="feedstock-container">
                            <CardHeader
                                isHidden={SMEsAreHidden}
                                toggleVisibility={toggleVisibilitySMEs}
                                cardName="SMEs"
                                handleDelete={null}
                                notValid={checkForErrorKeyword("SME")}
                            />
                            {SMEsAreHidden ? null : (
                                <>
                                    {data.smEs.map((sme, index) => (
                                        <SMEs
                                            errors={errors
                                                .filter((error) => error.field === "SME[" + index + "]")
                                                .map((error) => error.message)}
                                            dropdownValues={data.dropdownValues.filter(
                                                (item) => item.tab == "SMEs"
                                            )}
                                            picNumbers={data.picNumbers}
                                            key={index}
                                            data={sme}
                                            handleOnChangeSMEs={(e, dropDown) =>
                                                handleOnChangeSMEs(index, e, dropDown)
                                            }
                                            handleDeleteSMEs={() => handleDeleteSMEs(index)}
                                        />
                                    ))}
                                    {data.status == 1 ? (
                                        <div className="mt-3">
                                            <div className="text-end margin-button">
                                                <button
                                                    type="button"
                                                    className="add-feedstock-btn nested-button mx-4 my-1"
                                                    onClick={handleAddSMEs}
                                                >
                                                    <FontAwesomeIcon icon={plusDefinition} />
                                                    Add SME
                                                </button>
                                            </div>
                                        </div>
                                    ) : null}
                                </>
                            )}
                        </div>
                    </>
                ) : null}
                {activeTab == "Outputs" ? (
                    <>
                        <div className="error-container">
                            {errors
                                .filter((error) => error.field === "Output")
                                .map((error, index) => (
                                    <div
                                        className="error-text"
                                        key={index}
                                        style={{ marginBottom: "10px" }}
                                    >
                                        {error.message}
                                    </div>
                                ))}
                        </div>
                        <div>
                            {data.outputs.map((output, index) => (
                                <Output
                                    errors={errors
                                        .filter((error) => error.field === "Output[" + index + "]")
                                        .map((error) => error.message)}
                                    dropdownValues={data.dropdownValues.filter(
                                        (item) => item.tab == "Output"
                                    )}
                                    status={data.status}
                                    key={index}
                                    isCBE={data.isCBE}
                                    data={output}
                                    handleOnChangeOutput={(
                                        e?: React.ChangeEvent<any>,
                                        dropDown?
                                    ) => handleOnChangeOutput(index, e, dropDown)}
                                    handleDeleteOutput={() => handleDeleteOutput(index)}

                                    customLabelValues={data.customLabelValues.filter(
                                        (item => item.table == "Output")
                                    )}
                                    handleUpdateEditableTitle={handleUpdateEditableTitle}
                                    tAndP={data.tAndP.filter(
                                        (item => item.table == "Outputs")
                                    )}
                                />
                            ))}
                        </div>
                        {data.status == 1 ? (
                            <div className="mt-3">
                                <div className="text-end margin-button">
                                    <button
                                        type="button"
                                        className="add-feedstock-btn nested-button mx-4 my-1"
                                        onClick={handleAddOutput}
                                    >
                                        <FontAwesomeIcon icon={plusDefinition} />
                                        Add Output
                                    </button>
                                </div>
                            </div>
                        ) : null}
                    </>
                ) : null}
                {activeTab == "Impacts" ? (
                    <>
                        <Impacts
                            errors={errors
                                .filter((error) => error.field === "Impacts")
                                .map((error) => error.message)}
                            dropdownValues={data.dropdownValues.filter(
                                (item) => item.tab == "Impact"
                            )}
                            isCBE={data.isCBE}
                            data={data.impacts}
                            handleOnChangeImpacts={handleOnChangeImpacts}

                            customLabelValues={data.customLabelValues.filter(
                                (item =>
                                    item.table == "Impact")
                            )}
                            handleUpdateEditableTitle={handleUpdateEditableTitle}
                            tAndP={data.tAndP.filter(
                                (item => item.table == "Impacts")
                            )}
                        />
                    </>
                ) : null}
                {activeTab == "Market" ? (
                    <>
                        <div className="error-container">
                            {errors
                                .filter((error) => error.field === "Regulation")
                                .map((error, index) => (
                                    <div
                                        className="error-text"
                                        key={index}
                                        style={{ marginBottom: "10px" }}
                                    >
                                        {error.message}
                                    </div>
                                ))}
                            {errors
                                .filter((error) => error.field === "Directive")
                                .map((error, index) => (
                                    <div
                                        className="error-text"
                                        key={index}
                                        style={{ marginBottom: "10px" }}
                                    >
                                        {error.message}
                                    </div>
                                ))}
                        </div>
                        <Market
                            dropdownValues={data.dropdownValues.filter(
                                (item) =>
                                    item.tab == "Market" ||
                                    item.tab == "Regulation" ||
                                    item.tab == "Communication" ||
                                    item.tab == "Directive"
                            )}
                            errors={errors}
                            isCBE={data.isCBE}
                            data={data.market}
                            status={data.status}
                            handleOnChangeMarket={handleOnChangeMarket}
                            //Regulation
                            handleOnChangeRDC={handleOnChangeRDC}
                            handleAddRDC={handleAddRDC}
                            handleDeleteRDC={handleDeleteRDC}
                            //Directive
                            handleOnChangeDirective={handleOnChangeDirective}
                            handleAddDirective={handleAddDirective}
                            handleDeleteDirective={handleDeleteDirective}
                            //Communication
                            handleOnChangeCommunication={handleOnChangeCommunication}
                            handleAddCommunication={handleAddCommunication}
                            handleDeleteCommunication={handleDeleteCommunication}

                            customLabelValues={data.customLabelValues.filter(
                                (item =>
                                    item.table == "Market" ||
                                    item.table == "RDC" ||
                                    item.table == "Communication"
                                )
                            )}
                            handleUpdateEditableTitle={handleUpdateEditableTitle}
                            tAndP={data.tAndP.filter(
                                (item => item.table == "Market and Regulatory Barriers")
                            )}
                        />
                    </>
                ) : null}
                {activeTab == "Technology" ? (
                    <>
                        <div className="error-container">
                            {errors
                                .filter((error) => error.field === "Technology")
                                .map((error, index) => (
                                    <div
                                        className="error-text"
                                        key={index}
                                        style={{ marginBottom: "10px" }}
                                    >
                                        {error.message}
                                    </div>
                                ))}
                            {errors
                                .filter((error) => error.field === "Location")
                                .map((error, index) => (
                                    <div
                                        className="error-text"
                                        key={index}
                                        style={{ marginBottom: "10px" }}
                                    >
                                        {error.message}
                                    </div>
                                ))}
                        </div>
                        <div className="feedstock-container">
                            <CardHeader
                                isHidden={technologiesAreHidden}
                                toggleVisibility={toggleVisibilityTechnologies}
                                cardName="Technologies"
                                handleDelete={null}
                                notValid={checkForErrorKeyword("Technology")}
                            />
                            {technologiesAreHidden ? null : (
                                <>
                                    {data.technology.map((technologyData, index) => (
                                        <Technology
                                            status={data.status}
                                            errors={errors
                                                .filter(
                                                    (error) => error.field === "Technology[" + index + "]"
                                                )
                                                .map((error) => error.message)}
                                            key={index}
                                            data={technologyData}
                                            isCBE={data.isCBE}
                                            handleOnChangeTechology={(e) =>
                                                handleOnChangeTechnology(e, index)
                                            }
                                            handleDeleteTechnology={() =>
                                                handleDeleteTechnology(index)
                                            }
                                            dropdownValues={data.dropdownValues.filter(
                                                (item) => item.tab == "Technology"
                                            )}
                                        />
                                    ))}

                                    {data.status == 1 ? (
                                        <div className="mt-3">
                                            <div className="text-end margin-button">
                                                <button
                                                    type="button"
                                                    className="add-feedstock-btn nested-button mx-4 my-1"
                                                    onClick={handleAddTechnology}
                                                >
                                                    <FontAwesomeIcon icon={plusDefinition} />
                                                    Add Technology
                                                </button>
                                            </div>
                                        </div>
                                    ) : null}
                                </>
                            )}
                        </div>
                        <div className="feedstock-container">
                            <CardHeader
                                isHidden={locationsAreHidden}
                                toggleVisibility={toggleVisibilityLocations}
                                cardName="Location of the demonstration or flagship plant"
                                handleDelete={null}
                                notValid={checkForErrorKeyword("Location")}
                            />
                            {locationsAreHidden ? null : (
                                <>
                                    {data.locations.map((location, index) => (
                                        <LocationComponent
                                            errors={errors
                                                .filter(
                                                    (error) => error.field === "Location[" + index + "]"
                                                )
                                                .map((error) => error.message)}
                                            status={data.status}
                                            isCBE={data.isCBE}
                                            data={location}
                                            handleOnChangeLocation={(e) =>
                                                handleOnChangeLocation(e, index)
                                            }
                                            handleDeleteLocation={() => handleDeleteLocation(index)}
                                        />
                                    ))}

                                    {data.status == 1 ? (
                                        <div className="mt-3">
                                            <div className="text-end margin-button">
                                                <button
                                                    type="button"
                                                    className="add-feedstock-btn nested-button mx-4 my-1"
                                                    onClick={handleAddLocation}
                                                >
                                                    <FontAwesomeIcon icon={plusDefinition} />
                                                    Add Location
                                                </button>
                                            </div>
                                        </div>
                                    ) : null}
                                </>
                            )}
                        </div>
                        {data.isCBE ? (
                            <div className="feedstock-container">
                                <CardHeader
                                    isHidden={projectDevHidden}
                                    toggleVisibility={toggleVisibilityProjectDev}
                                    cardName="Sustainability of the process"
                                    handleDelete={null}
                                    notValid={checkForErrorKeyword("ProjectDevelopment")}
                                />
                                {projectDevHidden ? null : (
                                    <ProjectDevelopment
                                        errors={errors
                                            .filter((error) => error.field === "ProjectDevelopment")
                                            .map((error) => error.message)}
                                        isCBE={data.isCBE}
                                        data={data.projectDevelopment}
                                        handleOnChangeProjectDevelopment={
                                            handleOnChangeProjectDevelopment
                                        }

                                        customLabelValues={data.customLabelValues.filter(
                                            (item => item.table == "Project Development")
                                        )}
                                        handleUpdateEditableTitle={handleUpdateEditableTitle}
                                        tAndP={data.tAndP.filter(
                                            (item => item.table == "Technology")
                                        )}
                                    />
                                )}
                            </div>
                        ) : null}
                    </>
                ) : null}
                {activeTab == "Interconnections" ? (
                    <>
                        <div className="error-container">
                            {errors
                                .filter((error) => error.field === "Interconnection")
                                .map((error, index) => (
                                    <div
                                        className="error-text"
                                        key={index}
                                        style={{ marginBottom: "10px" }}
                                    >
                                        {error.message}
                                    </div>
                                ))}
                        </div>
                        {data.interconnections.map((interconnection, index) => (
                            <Interconnection
                                errors={errors
                                    .filter(
                                        (error) => error.field === "Interconnection[" + index + "]"
                                    )
                                    .map((error) => error.message)}
                                status={data.status}
                                key={index}
                                data={interconnection}
                                handleOnChangeInterconnection={(e, dropDown) =>
                                    handleOnChangeInterconnection(index, e, dropDown)
                                }
                                handleDeleteInterconnection={() =>
                                    handleDeleteInterconnection(index)
                                }
                                dropdownValues={data.dropdownValues.filter(
                                    (item) => item.tab == "Interconnection"
                                )}

                                customLabelValues={data.customLabelValues.filter(
                                    (item => item.table == "Interconnection")
                                )}
                                handleUpdateEditableTitle={handleUpdateEditableTitle}

                            />
                        ))}

                        {data.status == 1 ? (
                            <div className="mt-3">
                                <div className="text-end margin-button">
                                    <button
                                        type="button"
                                        className="add-feedstock-btn nested-button mx-4 my-1"
                                        onClick={handleAddInterconnection}
                                    >
                                        <FontAwesomeIcon icon={plusDefinition} />
                                        Add Interconnection
                                    </button>
                                </div>
                            </div>
                        ) : null}
                    </>
                ) : null}
                {activeTab == "SDGs" ? (
                    <>
                        <div className="error-container">
                            {errors
                                .filter((error) => error.field === "EuPolicies")
                                .map((error, index) => (
                                    <div
                                        className="error-text"
                                        key={index}
                                        style={{ marginBottom: "10px" }}
                                    >
                                        {error.message}
                                    </div>
                                ))}
                        </div>
                        <SDG
                            errors={errors
                                .filter(
                                    (error) => error.field === "SDG" || error.field === "Sdg"
                                )
                                .map((error) => error.message)}
                            dropdownValues={data.dropdownValues.filter(
                                (item) => item.tab == "SDG"
                            )}
                            data={data.sdg}
                            handleOnChangesdg={(e, dropDown) =>
                                handleOnChangesdg(e, dropDown)
                            }
                        />
                        <div className="feedstock-container">
                            <CardHeader
                                isHidden={euPoliciesAreHidden}
                                toggleVisibility={toggleVisibilityEuPolicies}
                                cardName="EU Policies"
                                handleDelete={null}
                                notValid={checkForErrorKeyword("EuPolicies")}
                            />
                            {euPoliciesAreHidden ? null : (
                                <>
                                    {data.euPolicies.map((euPolicy, index) => (
                                        <EuPolicy
                                            errors={errors
                                                .filter(
                                                    (error) => error.field === "EuPolicies[" + index + "]"
                                                )
                                                .map((error) => error.message)}
                                            status={data.status}
                                            key={index}
                                            data={euPolicy}
                                            handleOnChangeEuPolicy={(e) =>
                                                handleOnChangeEuPolicy(e, index)
                                            }
                                            handleDeleteEuPolicy={() => handleDeleteEuPolicy(index)}
                                            dropdownValues={data.dropdownValues.filter(
                                                (item) => item.tab == "EuPolicies"
                                            )}
                                        />
                                    ))}
                                    {data.status == 1 ? (
                                        <div className="mt-3">
                                            <div className="text-end margin-button">
                                                <button
                                                    type="button"
                                                    className="add-feedstock-btn nested-button mx-4 my-1"
                                                    onClick={handleAddEuPolicy}
                                                >
                                                    <FontAwesomeIcon icon={plusDefinition} />
                                                    Add EU policy
                                                </button>
                                            </div>
                                        </div>
                                    ) : null}
                                </>
                            )}
                        </div>
                    </>
                ) : null}
                <div className="form-group"></div>

                <div className="button-holder mt-5">
                    <a className="navlink" href={'/' + data.status}>
                        Back to List
                    </a>
                </div>
            </div>
        </>
    );
}

interface textDescription {
    [key: string]: string;
}
const textDescription: textDescription = {
    Feedstock:
        "Please provide information about the type of feedstock used in the project. <br/>If multiple feedstocks are used, please use the add feedstock button.",
    Technology:
        "Please provide information about the technology used in the project. <br/>If multiple technologies are used, please use the add technology button.",
    Outputs:
        "Please provide information about the output of the project. <br/>If the project has multiple outputs, please use the add output button.",
    "Value Chain":
        "Please provide information about the value chains enabled or created in the project. <br/>If the project creates/enables multiple value chains, use the add value chain button.",
    ParticipantsCBE:
        "Please provide information about the project's participants in terms of primary producers, biowaste managers, brand owners, and SMEs.<br/>If there are multiple participants under one category, use the add participant button.",
    ParticipantsBBI:
        "Please provide information about the project's participants in terms of SME. <br/>If the project has multiple SME, please use the add SME button.",
    Interconnections: "",
    Market: "",
    Impacts: "Does your project contribute to any of these impacts? ",
    SDGs: "",
};
export default QuestionnaireManagement;
